import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { validationClass } from "./CpntFormFieldGroup";
import Label from "./Label";

interface IProps {
  label?: string;
  formName: string;
  isMandatory?: boolean;
  popover?: string;
}
const PasswordInput: React.FC<IProps> = ({
  formName,
  label = formName,
  isMandatory,
  popover,
}) => {
  const [displayPassword, setDisplayPassword] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    register,
    getValues,
    getFieldState,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formState: { errors },
  } = useFormContext();

  return (
    <Label
      label={label}
      htmlFor={formName}
      errors={getFieldState(formName).error?.message}
      popover={popover}
      ismandatory={isMandatory}
    >
      <div className="input-group">
        <input
          type={displayPassword ? "text" : "password"}
          id={formName}
          {...register(formName)}
          className={`form-control ${validationClass(
            getFieldState(formName).error,
            !getFieldState(formName).error && getValues(formName)
          )}`}
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          style={{ color: "#3c3c3c" }}
          onClick={() => setDisplayPassword(!displayPassword)}
        >
          <i className={displayPassword ? "bi-eye" : "bi-eye-slash"} />
        </button>
      </div>
    </Label>
  );
};

export default PasswordInput;
